export default __webpack_public_path__ + "static/media/MTcarpaFull_Posterior.64087e2b.webp";